(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-mega-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ozy-category-menu')) {
  customElements.define('ozy-category-menu', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.menus = [...this.querySelectorAll('details.mega-menu')];
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.menus.forEach(menu => {
        const summary = menu.querySelector('summary');
        summary.setAttribute('aria-expanded','false');
        summary.addEventListener('click', event => {
          if(event.target.closest('.ozy-menu-destination')) {event.stopImmediatePropagation();this.clearTimers();return;}
          event.preventDefault(); event.stopImmediatePropagation();
          this.clearTimers();
          this.active === menu ? this.close(menu) : this.open(menu);
        }, {...options,capture:true});
        summary.addEventListener('pointerenter', event => {
          if(event.pointerType !== 'mouse' || !matchMedia('(hover:hover)').matches) return;
          this.clearTimers();
          this.openTimer = setTimeout(()=>this.open(menu),80);
        }, options);
      });
      this.addEventListener('pointerenter',()=>clearTimeout(this.closeTimer),options);
      this.addEventListener('pointerleave',event=>{
        if(event.pointerType !== 'mouse') return;
        this.clearTimers(); this.closeTimer=setTimeout(()=>this.close(this.active),180);
      },options);
      document.addEventListener('pointerdown',event=>{
        if(!this.contains(event.target)){this.clearTimers();this.close(this.active);}
      },options);
      this.addEventListener('keydown',event=>{
        if(event.key === 'Escape' && this.active){
          event.preventDefault();event.stopImmediatePropagation();
          const summary=this.active.querySelector('summary');
          this.clearTimers();this.close(this.active);summary.focus();
        }
      },{...options,capture:true});
      this.addEventListener('focusout',event=>{
        if(event.relatedTarget && !this.contains(event.relatedTarget)){this.clearTimers();this.close(this.active);}
      },options);
      document.addEventListener('shopify:block:select',event=>{
        const menu=event.target.closest('.ozy-category-mega');
        if(menu && this.contains(menu)){this.clearTimers();this.open(menu);}
      },options);
      this.reduced.addEventListener('change',()=>this.menus.forEach(menu=>this.finish(menu)),options);
    }
    clearTimers(){clearTimeout(this.openTimer);clearTimeout(this.closeTimer);}
    finish(menu){
      menu._animations?.forEach(animation=>animation.cancel());
      menu._animations=[]; menu._revision=(menu._revision||0)+1;
      if(menu !== this.active){menu.open=false;menu.querySelector('summary').setAttribute('aria-expanded','false');}
    }
    open(menu){
      if(this.active===menu) return;
      const previous=this.active;
      const startHeight=previous?.querySelector('.mega-menu__content').getBoundingClientRect().height||0;
      this.active=menu;
      this.menus.forEach(other=>this.finish(other));
      menu.open=true;
      menu.querySelector('summary').setAttribute('aria-expanded','true');
      const panel=menu.querySelector('.mega-menu__content');
      const inner=menu.querySelector('.ozy-mega-menu__inner');
      if(this.reduced.matches) return;
      const revision=menu._revision;
      const height=panel.getBoundingClientRect().height;
      menu._animations=[
        panel.animate([{height:startHeight+'px',opacity:previous?1:0},{height:height+'px',opacity:1}],{duration:320,easing:'cubic-bezier(.22,1,.36,1)',fill:'both'}),
        inner.animate([{opacity:0,transform:'translateY(-12px)'},{opacity:1,transform:'translateY(0)'}],{duration:280,easing:'cubic-bezier(.22,1,.36,1)',fill:'both'})
      ];
      Promise.all(menu._animations.map(animation=>animation.finished)).then(()=>{
        if(menu._revision===revision && this.active===menu) this.finish(menu);
      }).catch(()=>{});
    }
    close(menu){
      if(!menu || this.active!==menu) return;
      const panel=menu.querySelector('.mega-menu__content');
      const height=panel.getBoundingClientRect().height;
      this.finish(menu);this.active=null;
      menu.querySelector('summary').setAttribute('aria-expanded','false');
      if(this.reduced.matches){this.finish(menu);return;}
      const revision=menu._revision;
      const animation=panel.animate([{height:height+'px',opacity:1},{height:'0px',opacity:0}],{duration:220,easing:'cubic-bezier(.4,0,.6,1)',fill:'both'});
      menu._animations=[animation];
      animation.finished.then(()=>{if(menu._revision===revision && this.active!==menu)this.finish(menu);}).catch(()=>{});
    }
    disconnectedCallback(){this.clearTimers();this.active=null;this.menus?.forEach(menu=>this.finish(menu));this.controller?.abort();}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ozy-b2b-header"] && !Shopify.designMode) return;
  try {
    document.body.classList.add('ozy-b2b-customer');
  } catch(e) { console.error(e); }
})();

})();
